import { Link } from "react-router";
import type { ShopListing } from "@shared/contracts";
import { formatShopPrice } from "@shared/shop/price";
import { routes } from "../../app/routes";
import { GlowPanel } from "../../platform/ui/GlowPanel";

export function ListingCard({ listing }: { listing: ShopListing }) {
  return (
    <GlowPanel variant="feature" interactive className="post-card shop-card">
      <article>
        <p className="post-card__meta">{listing.type === "service" ? "Service" : "Product"}</p>
        <h2 className="post-card__title">
          <Link className="post-card__link" to={routes.listing(listing.slug)}>
            {listing.title}
          </Link>
        </h2>
        <p className="post-card__summary">{listing.summary}</p>
        <p className="shop-price">{formatShopPrice(listing)}</p>
        <p className="post-card__more" aria-hidden="true">
          View details <span>&rarr;</span>
        </p>
      </article>
    </GlowPanel>
  );
}
